// Source: app/scripts/directives/uploadPanel.js
Auction.directive('uploadPanel', [
  "$upload",
  "Attachment",
  "toaster",
  '$modal',
  '$filter',
  'Downloader',
  function ($upload, Attachment, toaster, $modal, $filter, Downloader) {
    return {
      restrict: 'E',
      transclude: false,
      scope: {
        objectId: "=",
        bean: "@",
        label: "@",
        accept: '@',
        data: '=',
        disabled: '=',
        edit: '=',
        exposeContainer: '=',
        hideDelete: '='
      },
      templateUrl: 'templates/upload.html',
      link: function (scope, element, attrs, ctrl, transclude, formCtrl) {

        scope.reload = function () {
          scope.attachments = Attachment.getAttachmentsByObjectId({
            id: scope.objectId,
            bean: scope.bean
          });
        };

        if (scope.objectId) {
          scope.reload();
        }


        var modalDeleteAttachment = $modal({
          scope: scope,
          template: '/templates/modal-form-notitle.tpl.html',
          contentTemplate: '/templates/delete-attachment.html',
          show: false
        });

        scope.deleteAttachmentDialog = function (id, bean) {
          scope.attachmentId = id;
          scope.bean = bean;
          modalDeleteAttachment.show();
        };

        scope.deleteAttachment = function (id, bean) {
          Attachment.deleteAttachment({
            id: scope.attachmentId,
            bean: scope.bean
          }, function () {
            scope.reload();
            modalDeleteAttachment.hide();
          });
        };

        function endsWith(str, end) {
          return (str.indexOf(end) + end.length) == str.length;
        }

        scope.extensions = scope.accept && scope.accept.split(',');

        scope.download = function (id) {
          Downloader.download('/data/rest/attachments/' + id);
        };

        scope.onFileSelect = function ($files) {
          if (scope.disabled) {
            return;
          }

          function onSuccess(data, status, headers, config) {
            toaster.pop('success', $filter('translate')('generic.success'),
              $filter('translate')('action.saved'));
            scope.reload();
          }

          function onError(data, status, headers, config) {
            toaster.pop('error', $filter('translate')('generic.error'),
              $filter('translate')('Upload failed'));
          }

          for (var i = 0; i < $files.length; i++) {
            var file = $files[i];
            var containsExtension = true;
            if (scope.extensions) {
              containsExtension = false;
              angular.forEach(scope.extensions, function (e) {
                if (endsWith(file.name, e)) {
                  containsExtension = true;
                }
              })
            }
            if (!containsExtension) {
              toaster.pop('error', $filter('translate')('generic.error'),
                $filter('translate')('action.invalid_extension'));
              return;
            }

            scope.upload = $upload.upload({
              url: "/data/rest/attachments/" + scope.bean + "/" + scope.objectId,
              data: scope.data,
              file: file
            }).success(onSuccess).error(onError);

          }
        };

        if (scope.exposeContainer) {
          scope.exposeContainer.scope = scope;
        }
      }
    };
  }
]);
